import { ConfettiCannons, ConfettiFireworks } from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const CONFETTI_COMPONENTS = {
  [TEMPLATES_TITLES.CONFETTI_CANNONS]: ConfettiCannons,
  [TEMPLATES_TITLES.CONFETTI_FIREWORKS]: ConfettiFireworks,
};

export const CONFETTI_DESIGNS_DATA = {
  [TEMPLATES_TITLES.CONFETTI_CANNONS]: {
    design: {},
  },
  [TEMPLATES_TITLES.CONFETTI_FIREWORKS]: {
    design: {},
  },
};

export default {
  CONFETTI_COMPONENTS,
  CONFETTI_DESIGNS_DATA,
};
